export default __webpack_public_path__ + "featured-base-layer-dark.f45fa41d.svg";